import { IFormStep } from "@rentiohq/web-shared-next/dist/utils/types/form";
import { uiSchema as uiSchema1 } from "./schema.addBankAccount.1";
import { EField, IExtraData } from "./schema.addBankAccount.types";

const getInitialValues = (extraData: IExtraData) => {
  return {
    [EField.OwnerName]: extraData.ownerName,
    [EField.IBAN]: extraData.iban ?? "BE",
  };
};

export const addBankAccountSchema =
  (extraData: IExtraData) => (): { formStepsSchema: IFormStep[] } => {
    const formStepsSchema = [
      {
        uiSchema: uiSchema1(extraData),
      },
    ];

    // @ts-ignore
    return { formStepsSchema, initialValues: getInitialValues(extraData) };
  };
